module.exports = __webpack_public_path__ + "static/img/apple.ef775513.png";